import React from 'react';
import PropTypes from 'prop-types';
// MATERIAL UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Typography from '@mui/material/Typography';
import { miEdgeBlue600 } from '../../../styles/miEdgeColors';

const styles = (theme) => ({
  dialogTitle: {
    color: '#FFF',
    backgroundColor: miEdgeBlue600,
    padding: theme.spacing(1),
  },
  title: {
    paddingLeft: theme.spacing(1),
    color: '#FFF',
  },
  dialogContent: {
    paddingLeft: theme.spacing(2),
  },
});

export class SubscriptionInfoDlg extends React.Component {
  render() {
    const { open } = this.props;

    return (
      <div>
        <Dialog
          open={open}
          fullWidth={true}
          maxWidth={'sm'}
          aria-labelledby="subscription-info-dialog-title"
          aria-describedby="subscription-info-dialog-content"
        >
          <DialogTitle
            id="subscription-info-dialog-title"
            sx={(theme) => styles(theme).dialogTitle}
          >
            <Typography sx={(theme) => styles(theme).title}>Subscription Information</Typography>
          </DialogTitle>
          <DialogContent sx={(theme) => styles(theme).dialogContent}>
            <DialogContentText id="subscription-info-dialog-content" component="div">
              <div>The renewal date on your account: {this.props.renewal_date}</div>
              <div>
                If you wish to cancel your subscription, please contact miEdge customer service at
                least 60 days before your next subscription renewal date. You can reach customer
                service via chat from the application, by phone at 877-9-miEdge (extension 1), or by
                email at&nbsp;
                <a href="mailto: customerservice@miedge.biz">customerservice@miedge.biz</a>.
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.props.onCloseRequested();
              }}
              color="primary"
            >
              <span>OK</span>
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

SubscriptionInfoDlg.propTypes = {
  open: PropTypes.bool,
  renewal_date: PropTypes.string.isRequired,
  onCloseRequested: PropTypes.func.isRequired,
};

export default SubscriptionInfoDlg;
